<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16KImER/tc-custom/9781423612186.jpg?1736860258876" alt="This image is the cover for the book 101 Things To Do With Ramen Noodles, 101 Things To Do With"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">101 Things To Do With Ramen Noodles, 101 Things To Do With
      </h1>
      <p class="bookDescription body article font2">
        <b>Expand your ramen repertoire with these inventive recipes in the bestselling cookbook series!</b><br/> Ramen is fast, easy, and filling, but what can be done to spruce it up and give it a whole new life? In this collection, featured on the <i>Today</i> show and the Food Network, there are 101 answers to that question, with recipes for: <br/> * Creamy Chicken Noodle Soup<br/> * Summer Garden Soup <br/> * Zucchini Salad<br/> * Creamy Beef and Broccoli Noodles <br/> * Ramen Burgers<br/> * Chicken Alfredo<br/> * Pork Chop Ramen<br/> * Tuna Noodle Casserole<br/> * Garlic Noodle Sauté<br/> * Beer Noodles (the ultimate college crowd pleaser!)<br/> * Chinese Veggie Noodles<br/> * Corny Cheese Noodles, and many more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Toni Patrick
      </h2>
      
      <p class="authorDescription body article">Toni Patrick is also the author of 101 Things to Do with Ramen Noodles, 101 Things to Do with Mac & Cheese, and 101 Things to Do with Canned Biscuits. She lives in Colorado.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e87f74a